module.exports = __webpack_public_path__ + "static/media/button_syunb96899c0d960b9e455f886257af9551a.webp";